import { actionEqual } from './utils';
import { reportPageUpdateKeyword } from 'actions/ReportPageActionCreators';

const defaultState: ReportPageState = {
  keyword: '',
};

export default function reportPage(
  state: ReportPageState = defaultState,
  action: Action
): ReportPageState {
  if (actionEqual(action, reportPageUpdateKeyword)) {
    const { keyword } = action.payload;

    return {
      ...state,
      keyword,
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/reportPage.ts